import React from "react";

const CommandHelp = () => {
    return (
        <div id="command-list-dialog">
            <div style={{ fontSize: "12px" }}> Augnito is voice driven with naturally spoken commands. Here are some examples to get you started.</div>
            <div className="">
                <div className="ControlListTitle" style={{ marginTop: "15px" }}>DICTATE</div>
                <div className="ControlListCommand">Full Stop / Comma / Colon</div>
                <div className="ControlListCommand">New line</div>
                <div className="ControlListTitle">EDIT &amp; FORMAT</div>
                <div className="ControlListCommand">Select All</div>
                <div className="ControlListCommand">Add Space</div>
                <div className="ControlListCommand">Bold that / Undeline that / Italicize that / Capitalize that / Delete that</div>
                <div className="ControlListCommand">Bold/Delete/Undeline/Italicize/Capitalize last word</div>
                <div className="ControlListCommand">Bold last &lt;n&gt; words [e.g. "Bold last 3 words"]</div>
                <div className="ControlListCommand">Undeline last &lt;n&gt; words</div>
                <div className="ControlListCommand">Italicize last &lt;n&gt; words</div>
                <div className="ControlListCommand">Capitalize last &lt;n&gt; words</div>
                <div className="ControlListCommand">Delete last &lt;n&gt; words</div>
                <div className="ControlListCommand">Bold/Delete/Undeline/Italicize/Capitalize last line</div>
                <div className="ControlListCommand">Bold last &lt;n&gt; line [e.g. "Bold last 3 line"]</div>
                <div className="ControlListCommand">Undeline last &lt;n&gt; line</div>
                <div className="ControlListCommand">Italicize last &lt;n&gt; line</div>
                <div className="ControlListCommand">Capitalize last &lt;n&gt; line</div>
                <div className="ControlListCommand">Delete last &lt;n&gt; line</div>
                <div className="ControlListTitle">SELECTION</div>
                <div className="ControlListCommand">Select last word</div>
                <div className="ControlListCommand">Select last &lt;n&gt; words</div>
                <div className="ControlListCommand">Select last line</div>
                <div className="ControlListCommand">Select last &lt;n&gt; line</div>
                <div className="ControlListCommand">Select &lt;word&gt; [e.g. "Select liver"]</div>
                <div className="ControlListTitle">NAVIGATION</div>
                <div className="ControlListCommand">Go to line start / Go to line end</div>
                <div className="ControlListTitle">LIST</div>
                <div className="ControlListCommand">Start/Stop Bullet List</div>
                <div className="ControlListCommand">Start/Stop Number List</div>
                <div className="ControlListTitle">CONTROL</div>
                <div className="ControlListCommand">Stop Mic</div>
            </div>
        </div>
    )
}

export default CommandHelp;